<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="dialog"
  >
    <div>
      <popup-header v-on:clickClose="closeModal()" />
      <!-- 제목 -->
      <v-row class="title-wrap">
        <v-col cols="12" class="big-title sm-padding">임직원 찾기</v-col>
      </v-row>
      <!-- 검색창 -->
      <v-row class="ma-0 mb-3" id="searchArea">
        <v-col cols="12" class="py-0 px-6">
          <v-text-field
            outlined
            clearable
            hide-details=""
            solo
            dense
            height="48"
            class="shadow-none search input-search"
            :append-icon="'mdi-magnify'"
            clear-icon="mdi-close-circle"
            v-model="searchSabunName"
            @change="doSearch()"
            placeholder="검색하기"
            @click:append="doSearch()"
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- 검색결과 -->
      <v-list flat class="overflow-y-auto">
        <v-list-item-group v-for="(employee, i) in searchList" :key="i">
          <v-list-item @click="doSelect(employee)">
            <v-list-item-content>
              <v-list-item-title
                ><span class="name" v-text="employee.name"></span
                ><span class="sub-desc ml-2" v-text="employee.jikweeNm"></span
                ><span class="sub-desc divider" v-text="employee.orgNm"></span
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </v-dialog>
</template>

<script>
/* 임직원검색 모달 (신청서 결재자/참조자) */
import PopupHeader from '@/components/common/PopupHeader.vue';
import { getMemberList } from '@/api/member.js';
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **

export default {
  mixins: [dialogMixin],

  data: () => ({
    modalName: 'search_executives',
    searchSabunName: '', // 조회사번이름
    searchList: [],
  }),

  computed: {
    GET_USER_DATA() {
      return this.$store.getters.GET_USER_DATA;
    },
  },

  methods: {
    /* 조회 */
    doSearch() {
      this.fetchMemberList();
    },

    /* 임직원선택 */
    doSelect(employee) {
      this.$emit('clickEmpSelect', employee);
    },

    /* 임직원정보목록조회 */
    async fetchMemberList() {
      const searchObj = {
        ssnEnterCd: this.GET_USER_DATA.ssnEnterCd,
        ssnSabun: this.GET_USER_DATA.ssnSabun,
        searchIncludeRa: 'N',
        searchSabunName: this.searchSabunName.trim(),
      };

      try {
        const response = await getMemberList(searchObj);
        this.searchList = response.data.data;
        return response;
      } catch (error) {
        console.log(error);
      }
    },
  },

  created() {
    //this.fetchMemberList();
  },

  components: {
    PopupHeader,
  },
};
</script>

<style>
.search.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  padding: 0px 16px;
}
.search .v-icon.v-icon {
  font-size: 1.125rem;
  color: #9ca3ab;
}
.v-list .name {
  font-weight: 500;
  line-height: 1.5;
  color: #363c43;
}
.v-list .sub-desc {
  font-size: 0.875rem;
  line-height: 1.71;
  color: #505961;
}
</style>
